define('modules/advanceSearch/models/industry.codes.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var IndustryCodesModel = BaseModel.extend({
        codes: [
            {id: 1, name: "Aerospace & Defense"},
            {id: 2, name: "Business Services"},
            {id: 3, name: "Construction"},
            {id: 4, name: "Computer Equipment & Peripherals"},
            {id: 5, name: "Consumer Goods"},
            {id: 6, name: "Diversified Industrials"},
            {id: 7, name: "Education"},
            {id: 8, name: "Electronics"},
            {id: 9, name: "Energy, Utilities, & Waste Treatment"},
            {id: 10, name: "Finance"},
            {id: 11, name: "Food, Beverages, & Tobacco"},
            {id: 12, name: "Forestry & Paper"},
            {id: 13, name: "Government"},
            {id: 14, name: "Healthcare"},
            {id: 15, name: "Hospitality"},
            {id: 16, name: "Insurance"},
            {id: 17, name: "Law Firms & Legal Services"},
            {id: 18, name: "Manufacturing"},
            {id: 19, name: "Media & Internet"},
            {id: 20, name: "Metals & Mining"},
            {id: 21, name: "Non-Profit Organizations"},
            {id: 22, name: "Real Estate"},
            {id: 23, name: "Retail"},
            {id: 24, name: "Software"},
            {id: 25, name: "Telecommunications"},
            {id: 26, name: "Transportation"},
            {id: 27, name: "Consumer Services"}
        ]
    });
    return IndustryCodesModel;
});

